import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { ConfigService } from './config.service';
import { Observable } from 'rxjs';
import { Level, ApplicationText, LevelProgress } from '../_models/model';
import { UserLoginModel } from '../_models/user-login.model';
import { UserRegistrationModel } from '../_models/user-registration.model';
import { catchError, map } from 'rxjs/operators';

export interface ILoginResponse {
  status: 'success' | 'failed';
}
export interface ILoginFailedResponse {
 status:'failed';
 message: string;
}
export interface ILoginSuccessResponse {
 status: 'success';
 accountname: string;
 auth_key: string;
 avatar: string;
}

@Injectable({
    providedIn: 'root'
})
export class ApiService {

    private readonly apiUri: string;
    private readonly API_DEVICE = 'api_device';

    /**
     * Headers to use when interceptor needs to be ignored, these will be striped again when sent.
     */
    private readonly ignoreInterceptorHeaders = new HttpHeaders({'X-Meta-Data': 'Ignore-Interceptor'});

    constructor(
      private configService: ConfigService,
      private http: HttpClient) {
        this.apiUri = this.configService.getApiUri();

        // Create an api key to register this device
        if (!localStorage.getItem('api_device')) {
            localStorage.setItem('api_device', this.createNonCompliantGuid());
        }
    }

    login(username: string, password: string): Observable<ILoginFailedResponse | ILoginSuccessResponse> {
        const body: UserLoginModel = {
            username: username,
            password: password
        };
        return this.http.post<any>(`${this.apiUri}login/`, body);
    }

    register(username: string, password: string, email: string): Observable<any> {
        const body: UserRegistrationModel = {
            username: username,
            password: password,
            email: email
        };
        return this.http.post<any>(`${this.apiUri}register/`, body);
    }

    sendAvatar(avatarString: string): Observable<any> {
        return this.http.post<any>(`${this.apiUri}user/`, {avatar: avatarString}, {});
    }

    getLevels(): Observable<Level[]> {
        return this.http.get<Level[]>(`${this.apiUri}level/`);
    }

    getApplicationTexts(): Observable<ApplicationText[]> {
        return this.http.get<ApplicationText[]>(`${this.apiUri}applicationText/`);
    }

    getLevelProgress(): Observable<LevelProgress[]> {
      return this.http.get<LevelProgress[]>(`${this.apiUri}levelProgress/`);
    }

    sendLevelProgress(levelProgress: LevelProgress): Observable<any> {
        return this.http.post<any>(`${this.apiUri}levelProgress/`, levelProgress, {});
    }

    getApiDevice(): string | null {
        return localStorage.getItem(this.API_DEVICE);
    }

    getColofon(): Observable<string> {
        return this.http.get<string>(`${this.apiUri}colofon/`);
    }

    postDiploma(email: string): Observable<Object> {
        const body = {
            email: email
        };
        return this.http.post(`${this.apiUri}diploma/`, body);
    }

    /**
     * Generates a non-compliant UUID, just needed for creating a unique API-device key.
     */
    private createNonCompliantGuid(): string {
        function s4() {
          return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
      }
}
